const emojiRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi

export const doesStringContainEmojis = (str: unknown): boolean => {
  if (typeof str !== 'string') return false

  return emojiRegex.test(str)
}

export const countStringBytes = (str: unknown): number => {
  if (typeof str !== 'string') return 0

  const encoder = new TextEncoder()
  return encoder.encode(str).length
}

/* Dynamically calculate min value for field minCurrentSunMode (ModbusTcp, Solar ratio) */
export const calculateMinimumMinCurrentSunModeValue = (minCurrent: number): number => {
  if (minCurrent === 0) return 0

  return Math.ceil(100 / minCurrent)
}
